import React, { useState, useEffect, useRef } from "react";

import axios from "axios";
import { IMG_URL } from "../../config";

import Dashboard from "../Dashboard/Dashboard";
import "../../components/Profile/Profile.css";
import "./Notifications.css";


// import pink from "../../images/down-pink.svg";
// import gren from "../../images/down-gren.svg";
import "../../components/ResultTwo/ResultTwo.css";
import yellow from "../../images/yellowbadge.svg";
import star from "../../images/star.png";
import redb from "../../images/red-badge.svg";
import lock from "../../images/lock1.svg";
import grap from "../../images/greybadge.svg";
import pur from "../../images/purple-badge.svg";
import yel from "../../images/yellowbadge.svg";

import { END_URL } from "../../config";
import gren from "../../images/test2.jpg";
import pk from "../../images/pink.png";
import gn from "../../images/green.png";
import loadimg from "../../images/loader_wish.gif";

function Notifications({ token, Notification ,globaltest}) {


    console.log(Notification,'Notification');


  return (
    <div>
      <div className="result-cont profileCont achiev">
        <div className="container-fluid">
          <div className="row">

            <div className="col-12 col-sm-12 col-md-3 col-lg-3 das-res">
              <Dashboard globaltest={globaltest}  />
            </div>

              <div className={`col-12 col-sm-12 col-md-7 col-lg-7 profile-mid achiev-mid acheivement-cont`}>


                        <div className="profile-inner">
                        

                              <div className='restwo-cont'>
                            
                                <div className="restwo-cont-sub">
                                    <div className="restwo-titl">
                                        <h5>Notifications</h5>
                                    </div>
            
                                    <div className="restwo-badgeDiv">
            
                                        <div className="resttrwo-Box">
            
                                              {Array.isArray(Notification) && Notification.length > 0 ? (

                                                    Notification.map((item, index) => (
                                                    <div key={index} className="notification-card">

                                                        <div className="notification-header">
                                                        {/* <h6 className="notification-title">
                                                            {item.source === "32_question" && "32 Question Notification"}
                                                            {item.source === "zoom" && "Zoom Notification"}
                                                            {item.source === "user" && "User Notification"}
                                                        </h6> */}
                                                        </div>

                                                        <div className="notification-body">

                                                        {item.type === "text" && item.content && (
                                                            <div
                                                            className="notification-text"
                                                            dangerouslySetInnerHTML={{ __html: item.content }}
                                                            />
                                                        )}

                                                        {item.type === "image" && item.image && (
                                                            <div className="notification-image">
                                                            <img
                                                                src={`${IMG_URL}/d0/${item.image}`}
                                                                alt="Notification"
                                                                className="img-fluid"
                                                            />
                                                            </div>
                                                        )}

                                                        </div>

                                                    </div>
                                                    ))
                                                    ) : (
                                                        <div className="no-notification">
                                                        <p>No notifications available.</p>
                                                        </div>
                                                    )}

                                        </div>
            
                                    </div>
            
            
                                </div>
            
                            </div>
                        
                        </div>

              </div>
          
          
          </div>
        </div>
      </div>

    </div>
  );
}

export default Notifications;
